module.exports = __webpack_public_path__ + "img/Rod_bare.076f97e4.png";